/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import AchievementLevel from '../../../common/components/AchievementLevel';
import AchievementCategoryName from '../../../common/components/AchievementCategoryName';
import UnlockedBy from './UnlockedBy';
import icon from 'flarum/common/helpers/icon';

export default class AchievementUsersHero extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { achievementLevel, loading } = this.attrs;

		if (!achievementLevel || loading) {
			return null;
		}

		const achievement = achievementLevel.achievement();
		const category = achievement.category();

		return (
			<div className="AchievementUsersHero Hero">
				{!loading &&
					achievementLevel && [
						<div className="AchievementUsersHero-breadcrumbs">
							<Link href={app.route('achievements', { category: category.id() })} className="AchievementUsersHero-categoryName">
								<AchievementCategoryName category={category} />
							</Link>
							<span>{icon('far fa-chevron-right')}</span>
							<Link href={app.route('achievement', { id: achievement.id() })} className="AchievementUsersHero-achievementName">
								{achievement.name()}
							</Link>
						</div>,
						<AchievementLevel achievementLevel={achievementLevel} showDesc={true} />,
						<div className="AchievementUsersHero-unlockedBy">
							<UnlockedBy achievementLevel={achievementLevel} />
						</div>,
					]}
			</div>
		);
	}
}
